import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'

import { getImageSource, konkatenoiKoonti, pisteytys } from '../../utils/utils';
import { shufflaa } from '../../utils/randomize'

import { data } from './data/data_03_sauvojen_tsekkaus.js'
// import kuva from './images/sauvat.gif'
import kuva from './images/sauvat_mustat_teksti_ok.png'
// import kuva from './images/sauvat_mustat_teksti_ok_300x430.png'
import { ImageMagnifier } from '../../additionalComponents/magnifier.tsx';


const SauvojenTsekkaus = ({ scoreHandler, visibilityHandler, soundsOn, timeHandler }) => {


    let lista = null

    //Statemjat
    const [teksti, setTeksti] = useState('')
    const [optiot1, setOptiot1] = useState([])
    const [optiot2, setOptiot2] = useState([])
    const [optiot2Populoitu, setOptiot2Populoitu] = useState(false)
    const [klikattuOptio, setKlikattuOptio] = useState('')

    const [time1, setTime1] = useState(0)

    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);


    //populoi aluksi teksti + optiot (alkuperäinen järjestys)
    useEffect(() => {
        setOptiot1(data.optiot)
        setTeksti(data.kysymysteksti)
        setTime1(Date.now())
    }, [])

    // optiot2:een shufflattu järjestys
    useEffect(() => {//
        if (optiot1.length != 0) {
            setOptiot2(shufflaa(optiot1))
        }
    }, [optiot1])


    const klikattuVaihtoehtoa = (optio) => {


        if (soundsOn) {

            if (Number(optio.pisteet) > 0) {
                playCorrectAnswer()
            }
            else {
                playWrongAnswer()
            }

        }


        //välitetään scenepohja-välikomponentille optioon kovakoodattu palaute 
        scoreHandler(optio, data.scene, data.maxp)


        visibilityHandler(optio.valinta)
    }

    if (optiot2.length != 0) {
        lista = optiot2.map(optio =>
            <li key={optio.id}>

                <span className='clickable'
                    // 
                    onClick={() => klikattuVaihtoehtoa(optio)}

                >
                    {optio.teksti}
                </span>
            </li>
        );
    }
    return (

        <div className='sceneContainer' style={{ overflow: 'scroll' }}>

            <div id='image' className='kuvaBox' >
                {/* <img className='sameSizeImg' src={kuva} alt='kuva' style={{ objectFit: 'cover' }} /> */}

                <ImageMagnifier
                    width={"550px"}
                    src={kuva}
                />


            </div>

            <div id='question'>
                <h4>{(teksti != null && teksti != "") ? teksti : null}</h4>
            </div>

            <div id='actions'>
                <ul>
                    {lista}
                </ul>
            </div>
        </div>
    )

}

export default SauvojenTsekkaus